module.exports = __webpack_public_path__ + "assets/img/fncone.2fd15b33.png";